import { render } from "./ExportInterfaceForm.vue?vue&type=template&id=73643d50&scoped=true&ts=true"
import script from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"
export * from "./ExportInterfaceForm.vue?vue&type=script&lang=ts"

import "./ExportInterfaceForm.vue?vue&type=style&index=0&id=73643d50&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73643d50"]])

export default __exports__